import React from "react"
import styles from "./MenuItem.module.scss"
import cn from "classnames"
import MenuIcon from "../MenuIcon/MenuIcon"

export interface MenuItemComponentProps {
    id: string
    title: string
    isSelected: boolean
    onClick: () => void
    testId?: string
    icon?: string
    inHeader?: boolean
    useDivider?: boolean
    size?: "sm" | "md"
}

const MenuItemComponent: React.FC<MenuItemComponentProps> = props => {
    const { id, title, isSelected, onClick, testId, icon, inHeader, useDivider = true, size = "md" } = props
    return (
        <>
        <button
            className={cn(styles.menuItem, isSelected && styles.menuItem_selected)}
            onClick={() => onClick()}
            data-testid={testId}
        >
            <div className={cn(styles.menuItem__container, !inHeader && styles.menuItem_sidebar)}>
                <MenuIcon menuId={id} className={cn(styles.menuItem__menuIcon, size === "sm" && styles.menuItem__menuIcon_sm)} iconUrl={icon} />
                {/* {!inHeader && <div className={styles.menuItem__title}>{title}</div>} */}
            </div>
        </button>
        {useDivider && <div>
            <div className="sidebar__divider">
                <div className="sidebar__divider-element" />
            </div>
        </div>}
        </>
    )
}

export default MenuItemComponent
